import type { PayloadAction } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import type { BaseObject } from 'common/types'

type VelocityAllowedType = {
  id: string
  items: BaseObject[]
}

export const velocityAllowedTypesAdapter = createEntityAdapter<VelocityAllowedType>({
  selectId: entity => entity.id,
})

const initialState = velocityAllowedTypesAdapter.getInitialState()

export const velocityAllowedTypesSlice = createSlice({
  name: 'velocityAllowedTypes',
  initialState,
  reducers: {
    clearVelocityAllowedTypes() {
      return initialState
    },
    addVelocityAllowedTypes(state, action: PayloadAction<VelocityAllowedType>) {
      velocityAllowedTypesAdapter.upsertOne(state, action.payload)
    },
  },
})

export default velocityAllowedTypesSlice.reducer
